module.exports = __webpack_public_path__ + "static/microblink-bw-11e68ffbfbd59db43a83df2a13adbe3e.jpg";